<template>
    <svg
        width="660"
        height="690"
        viewBox="0 0 660 690"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M102 25H558C564.075 25 569 29.9249 569 36V654C569 660.075 564.075 665 558 665H102C95.9249 665 91 660.075 91 654V36C91 29.9249 95.9249 25 102 25Z"
            fill="var(--et-colors-background)"
            stroke="#EAECF0"
        />
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="20"
            font-weight="600"
            letter-spacing="0em"
        >
            <tspan x="126" y="88.1">Terms &#38; Conditions</tspan>
        </text>
        <path
            d="M492 68C492 63.5817 495.582 60 500 60H526C530.418 60 534 63.5817 534 68V94C534 98.4183 530.418 102 526 102H500C495.582 102 492 98.4183 492 94V68Z"
            fill="#8194B1"
            fill-opacity="0.1"
        />
        <path
            d="M515.883 79.6777L521.586 85.3803M504.328 89.6719H514.734M516.877 73.9931C516.488 73.6046 516.537 73.6518 516.252 73.3882C515.302 72.5127 513.821 72.5876 512.84 73.4298C512.387 73.8211 511.927 74.2484 511.178 74.9977C510.636 75.5292 510.115 76.0813 509.616 76.653C508.761 77.6436 508.697 79.1435 509.58 80.1106C509.834 80.3881 509.778 80.3382 510.154 80.7142C510.529 81.0902 510.479 81.0347 510.758 81.2886C511.725 82.171 513.225 82.1072 514.215 81.2525C514.669 80.8612 515.13 80.4325 515.871 79.6916C516.621 78.9409 517.047 78.4817 517.439 78.028C518.281 77.0484 518.357 75.5679 517.48 74.6175C517.217 74.3331 517.265 74.3802 516.877 73.9931ZM505.716 86.8969V89.6719H513.347V86.8969C513.347 86.5289 513.201 86.176 512.94 85.9158C512.68 85.6556 512.327 85.5094 511.959 85.5094H507.103C506.735 85.5094 506.382 85.6556 506.122 85.9158C505.862 86.176 505.716 86.5289 505.716 86.8969Z"
            stroke="var(--et-colors-text)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="16"
            font-weight="600"
            letter-spacing="0em"
        >
            <tspan x="126" y="161.28">&#xa7; 1. Definitions</tspan>
        </text>
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="16"
            font-weight="600"
            letter-spacing="0em"
        >
            <tspan x="126" y="329.28">&#xa7; 2. General provisions</tspan>
        </text>
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="16"
            font-weight="600"
            letter-spacing="0em"
        >
            <tspan x="126" y="545.28">&#xa7; 3. Conclusion of sales agreement</tspan>
        </text>
        <path
            d="M526 182H134C129.582 182 126 185.582 126 190C126 194.418 129.582 198 134 198H526C530.418 198 534 194.418 534 190C534 185.582 530.418 182 526 182Z"
            fill="#8194B1"
            fill-opacity="0.1"
        />
        <path
            d="M126 214C126 209.582 129.582 206 134 206H510C514.418 206 518 209.582 518 214C518 218.418 514.418 222 510 222H134C129.582 222 126 218.418 126 214Z"
            fill="#8194B1"
            fill-opacity="0.1"
        />
        <path
            d="M126 238C126 233.582 129.582 230 134 230H526C530.418 230 534 233.582 534 238C534 242.418 530.418 246 526 246H134C129.582 246 126 242.418 126 238Z"
            fill="#8194B1"
            fill-opacity="0.1"
        />
        <path
            d="M126 262C126 257.582 129.582 254 134 254H394C398.418 254 402 257.582 402 262C402 266.418 398.418 270 394 270H134C129.582 270 126 266.418 126 262Z"
            fill="#8194B1"
            fill-opacity="0.1"
        />
        <path
            d="M126 358C126 353.582 129.582 350 134 350H526C530.418 350 534 353.582 534 358C534 362.418 530.418 366 526 366H134C129.582 366 126 362.418 126 358Z"
            fill="#8194B1"
            fill-opacity="0.1"
        />
        <path
            d="M126 382C126 377.582 129.582 374 134 374H502C506.418 374 510 377.582 510 382C510 386.418 506.418 390 502 390H134C129.582 390 126 386.418 126 382Z"
            fill="#8194B1"
            fill-opacity="0.1"
        />
        <path
            d="M126 406C126 401.582 129.582 398 134 398H446C450.418 398 454 401.582 454 406C454 410.418 450.418 414 446 414H134C129.582 414 126 410.418 126 406Z"
            fill="#8194B1"
            fill-opacity="0.1"
        />
        <path
            d="M126 430C126 425.582 129.582 422 134 422H487C491.418 422 495 425.582 495 430C495 434.418 491.418 438 487 438H134C129.582 438 126 434.418 126 430Z"
            fill="#8194B1"
            fill-opacity="0.1"
        />
        <path
            d="M126 454C126 449.582 129.582 446 134 446H508C512.418 446 516 449.582 516 454C516 458.418 512.418 462 508 462H134C129.582 462 126 458.418 126 454Z"
            fill="#8194B1"
            fill-opacity="0.1"
        />
        <path
            d="M126 478C126 473.582 129.582 470 134 470H512C516.418 470 520 473.582 520 478C520 482.418 516.418 486 512 486H134C129.582 486 126 482.418 126 478Z"
            fill="#8194B1"
            fill-opacity="0.1"
        />
        <path
            d="M126 574C126 569.582 129.582 566 134 566H526C530.418 566 534 569.582 534 574C534 578.418 530.418 582 526 582H134C129.582 582 126 578.418 126 574Z"
            fill="#8194B1"
            fill-opacity="0.1"
        />
        <path
            d="M126 598C126 593.582 129.582 590 134 590H480C484.418 590 488 593.582 488 598C488 602.418 484.418 606 480 606H134C129.582 606 126 602.418 126 598Z"
            fill="#8194B1"
            fill-opacity="0.1"
        />
        <path
            d="M126 622C126 617.582 129.582 614 134 614H288C292.418 614 296 617.582 296 622C296 626.418 292.418 630 288 630H134C129.582 630 126 626.418 126 622Z"
            fill="#8194B1"
            fill-opacity="0.1"
        />
    </svg>
</template>
